import { Component, OnInit } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';
import { DocumentStatusesEnum } from "app/main/pages/documents/dto/document-statuses.enum";

@Component({
  selector: 'app-latestactivitywidget',
  templateUrl: './latestactivitywidget.component.html',
  styleUrls: ['./latestactivitywidget.component.scss']
})
export class LatestactivitywidgetComponent implements OnInit {

  public latestAcitivites$ = this._dashboardFacade$.latestActivity$;
  public documentStatusesEnum = DocumentStatusesEnum;
  constructor(private _dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this._dashboardFacade$.fetchLatestActivity()
  }

  getTimelinePointClass(status: string):string{
      switch (status) {
          case DocumentStatusesEnum.Sent:
              return 'primary';
          case DocumentStatusesEnum.Draft:
              return 'info';
          case DocumentStatusesEnum.Uploaded:
              return 'info';
          case DocumentStatusesEnum.Waiting:
              return 'info';
          case  DocumentStatusesEnum.Delivered:
              return 'warning';
          case DocumentStatusesEnum.Expired:
              return 'secondary';
          case DocumentStatusesEnum.Revoke:
              return 'secondary';
          case DocumentStatusesEnum.Approved:
              return 'success';
          case DocumentStatusesEnum.Signed:
              return 'success';
          case DocumentStatusesEnum.Viewed:
              return 'primary';
          case DocumentStatusesEnum.Rejected:
              return 'warning';
          default:
              return '';
      }
  }
}